export default "__VITE_ASSET__hAdbAGOO__"